import React, { useState, useEffect } from "react";
import { sql, globalFilter, addToHistory } from "../../apis/utility";
import { useLocation } from "react-router-dom";

import ReactFC from "react-fusioncharts";
import FusionCharts from "fusioncharts";
import excelexport from "fusioncharts/fusioncharts.excelexport";
import Charts from "fusioncharts/fusioncharts.charts";
import PowerCharts from 'fusioncharts/fusioncharts.powercharts';
// import GammelTheme from 'fusioncharts/themes/fusioncharts.theme.gammel';
ReactFC.fcRoot(FusionCharts, Charts, PowerCharts, excelexport);

export default function VSOPulse(props) {
    const location = useLocation();
    addToHistory({ title: "VS Ortho Pulse", url: location })
    const
        whereSubjects = props.selectedSubjects.length > 0
            ? 'and SUBJID in ("' + props.selectedSubjects.join('","') + '")'
            : '',
        sqlStatement = `select VSDY, VSSTRESN, VSTESTCD from vs where VSTESTCD in ('OPULSE') ${whereSubjects}`,
        [subtitle, setSubtitle] = useState(null),
        [dataSource, setDataSource] = useState(null),
        { low, high } = props.normalRanges.VSPULSE

    useEffect(() => {
        setSubtitle(globalFilter(props.selectedOptions))
        sql(props.studyDatabase, sqlStatement)
            .then((res) => {
                if (res.message === "success") {
                    // console.log('res.data', res.data)
                    // console.log('low', low, 'high', high)
                    const categoryValues = [...new Set(res.data
                        .filter((row) => ('OPULSE').includes(row.VSTESTCD))
                        .map((row) => Number(row.VSDY)))]
                        .sort((a, b) => a - b),
                        categories = [{
                            category:
                                categoryValues.map((item) => { return { label: item.toString() } })
                        }],
                        opulseSeries = {
                            seriesname: 'Opulse', data:
                                categories[0].category.map((category) => {
                                    const pulseData = res.data
                                        .filter((row) => row.VSTESTCD === 'OPULSE' && row.VSDY === category.label)
                                    if (pulseData.length > 2) { return { value: pulseData.map((item) => Number(item.VSSTRESN)).join(',') } }
                                    else {
                                        const values = pulseData.map((item) => Number(item.VSSTRESN)).join(',');
                                        return { "value": values + ',' + values + ',' + values }
                                    }
                                })
                        },
                        dataSource = {
                            chart: {
                                "caption": "Orthostatic Pulse (" + props.study + ')',
                                "subcaption": subtitle,
                                "yaxisname": "Pulse",
                                "xaxisname": "Day",
                                "yAxisMaxValue": "130",
                                "yAxisMinValue": "40",
                                // theme: "gammel",
                                "bgColor": "EEEEEE,CCCCCC",
                                "bgratio": "60,40",
                                "bgAlpha": "70,80",
                                "bgAngle": "180",
                                "plotspacepercent": "25",
                                "numVisiblePlot": "222",
                                "showalloutliers": "1",
                                "exportEnabled": "1"
                            },
                            categories: categories,
                            dataset: [opulseSeries],
                            "trendlines": [{
                                "line": [{
                                    "isTrendZone": "1",
                                    "startvalue": 40,
                                    "endValue": low,
                                    "color": "#0000ff",
                                    "valueOnRight": "1",
                                    "alpha": "20",
                                    "tooltext": "Low Pulse",
                                    "displayvalue": "Low"
                                }, {
                                    "isTrendZone": "1",
                                    "startvalue": high,
                                    "endValue": 130,
                                    "color": "#ff0000",
                                    "valueOnRight": "1",
                                    "alpha": "20",
                                    "tooltext": "High Pulse",
                                    "displayvalue": "High"
                                }]
                            }]
                        }
                    // console.log('dataSource', dataSource)
                    setDataSource(dataSource)
                }
            });
    }, [props.selectedSubjects, props.study, props.studyDatabase, props.selectedOptions, subtitle, sqlStatement, low, high])

    return (<>
        {dataSource
            ? <ReactFC
                type="boxandwhisker2d"
                width="100%"
                height={props.screenHeight * 0.8}
                dataFormat="JSON"
                dataSource={dataSource}
            />
            : "loading"}
    </>)
}